// src/components/km/kmLabels.js
// Etichette di sola presentazione, condivise tra ResourceSelfAssessmentPanel
// (azione singola) e HrSelfAssessmentConsole (azione massiva sulla longlist).
// Non calcolano né inferiscono nulla: lo stato arriva sempre dal backend.

export const STATE_LABELS = {
  R1: 'Inbound',
  R2: 'In qualifica',
  R3: 'Proponibile',
  R3a: 'Proponibile, mai staffato',
  R3b: 'Collaboratore attualmente staffato',
  R3c: 'Collaboratore ex-staffato',
  R4: 'Da cancellare',
};

// Etichetta leggibile dello stato risorsa (mai il codice R1..R4 a schermo,
// SAL 02/10 azione 23). Per R3 usa il sottostato se presente.
export function statoRisorsaLabel(stato, sottostato) {
  if (!stato) return null;
  const chiave = stato === 'R3' && sottostato ? sottostato : stato;
  return STATE_LABELS[chiave] || STATE_LABELS[stato] || stato;
}

// V32 (AF v2.0, §4.1): "Vale una regola vincolante: se alla risorsa è già
// stato inviato un Self-Assessment «recentemente» (vedi V32), si procede
// sempre per via diretta, per non sottoporre alla risorsa una seconda
// somministrazione ravvicinata." Non è facoltativo. Soglia: parametro di
// sistema, valore predefinito 30 giorni (V32) — qui replicato al suo
// default finché il backend non lo espone come parametro configurabile
// (e non lo applica anche lato server, vedi nota per Armando). RIMESSO
// il 29/09 dopo una rilettura del testo AF: era stato tolto per errore,
// scambiando "valore hardcoded invece che da parametro" per "controllo
// non richiesto" — il controllo è richiesto, solo il valore è fisso.
export const SOGLIA_INVIO_RECENTE_GIORNI = 30;

export function giorniDallInvio(dataIso) {
  if (!dataIso) return null;
  const t = new Date(dataIso).getTime();
  if (Number.isNaN(t)) return null;
  return Math.floor((Date.now() - t) / 86400000);
}

export function invioRecente(dataIso) {
  const g = giorniDallInvio(dataIso);
  return g !== null && g < SOGLIA_INVIO_RECENTE_GIORNI;
}

// Stati per cui l'Analisi Funzionale v1.3 (§7) non prevede invio SA.
export const NON_INVITABLE_STATES = ['R1', 'R4'];

// Id delle fixture DEV_ definite in api/mockHrConsole.js — usati per il
// selettore "Testa con risorsa fittizia" nei pannelli, visibile solo in
// HR_CONSOLE_MOCK_MODE. Nessun id reale corrisponde a queste stringhe: senza
// questo selettore i pannelli singoli non sono testabili cliccando candidati
// reali (i loro id non combaciano mai con le fixture).
export const DEV_TEST_RESOURCE_IDS = [
  'DEV_R2_001',
  'DEV_R3A_001',
  'DEV_R3B_001',
  'DEV_R3C_001',
  'DEV_R2_002',
  'DEV_R1_001',
  'DEV_R4_001',
];
